import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { type IResponseContact } from 'entities/Contacts/api/types'
import { CompareVCardsContent } from 'entities/VCard/ui/CompareVCardsContent/CompareVCardsContent'
import { EditVCardContent } from 'entities/VCard/ui/EditVCardContent/EditVCardContent'
import { Contact } from 'entities/Contacts/model/Contact'
import { VCard } from 'entities/VCard/model/VCard'

export class VCardStore {
  constructor() {
    makeAutoObservable(this)
  }

  private _modalId = ''
  private _modalVCard: VCard | null = null
  private _currentVCard: VCard | null = null
  private _newVCard: VCard | null = null
  private _duplicateContacts: Contact[] = []
  private _isLoading = false
  private _isCurrentSelected = true

  get modalVCard() {
    return this._modalVCard
  }

  get currentVCard() {
    return this._currentVCard
  }

  get newVCard() {
    return this._newVCard
  }

  get isCurrentSelected() {
    return this._isCurrentSelected
  }

  get duplicateContacts() {
    return this._duplicateContacts
  }

  get isLoading() {
    return this._isLoading
  }

  setIsLoading = (value: boolean) => {
    this._isLoading = value
  }

  openVCard = (vCard: VCard) => {
    this._modalId = nanoid()
    this._duplicateContacts = []
    this._modalVCard = vCard

    modalStore.addModal({
      id: this._modalId,
      pureContent: true,
      ModalContentProps: {
        store: this,
      },
      ModalContent: EditVCardContent,
      title: 'vCard',
      width: 400,
    })
  }

  openVCardContent = (vCard: VCard, duplicateContacts: IResponseContact[] = []) => {
    this._duplicateContacts = duplicateContacts.length
      ? duplicateContacts.map((contact) => new Contact(contact))
      : []
    this._modalVCard = duplicateContacts.length
      ? new VCard({
          phone: this._duplicateContacts[0].formatted_number,
          first_name: this._duplicateContacts[0].first_name,
          email: this._duplicateContacts[0].email,
          last_name: this._duplicateContacts[0].last_name,
          color: this._duplicateContacts[0].color,
        })
      : vCard
  }

  onCloseVCardContent = () => {
    this._duplicateContacts = []
    this._isCurrentSelected = true
  }

  openCompareContent = (newVCard: VCard, duplicateContacts: IResponseContact[]) => {
    this.onCloseModal()
    this._modalId = nanoid()
    this._isCurrentSelected = true
    this._newVCard = newVCard
    this._duplicateContacts = duplicateContacts.map((contact) => new Contact(contact))
    this._currentVCard =
      this._duplicateContacts[0] &&
      new VCard({
        phone: this._duplicateContacts[0].formatted_number,
        first_name: this._duplicateContacts[0].first_name,
        email: this._duplicateContacts[0].email,
        last_name: this._duplicateContacts[0].last_name,
        color: this._duplicateContacts[0].color,
      })
    modalStore.addModal({
      id: this._modalId,
      pureContent: true,
      ModalContentProps: {
        store: this,
      },
      ModalContent: CompareVCardsContent,
      title: 'vCard',
      width: 600,
    })
  }

  onCloseModal = () => {
    this._duplicateContacts = []
    this._isCurrentSelected = true
    modalStore.closeModal(this._modalId)
  }

  setCurrentSelected = (value: boolean) => {
    this._isCurrentSelected = value
  }
}
